var exports = {
  "k": "x4c3adb35--7c59e9--container",
};

module.exports = exports;
